import { render, staticRenderFns } from "./BetaModal.vue?vue&type=template&id=605e7b2e&"
import script from "./BetaModal.vue?vue&type=script&lang=js&"
export * from "./BetaModal.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/components/ig-beta.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports